/**
 * An action step is either { title, body } or a bare string.
 *
 * aauModule writes objects; passingAccuracyModule and passingModule write
 * strings. The ActionSteps component only ever read `.title` and `.body`, so
 * every string item rendered as a numbered circle with nothing beside it.
 * Nothing failed: a React component handed `undefined` renders nothing and
 * says nothing, so twelve blank rows shipped across two masterclasses.
 *
 * Normalised here rather than by rewriting the copy, because a one-line step
 * genuinely has no body and inventing titles to fit a component is the wrong
 * way round.
 *
 * A leaf module with no imports, so a test can reach it without pulling the
 * reader and, through it, the Supabase client.
 */
export const asStep = (it) =>
  (typeof it === "string"
    ? { title: it, body: "" }
    : (it && typeof it === "object" ? it : { title: "", body: "" }));

export default asStep;
